import React from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  Modal,
  TableAdv,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { mapTableRows } from "../../../../../../../utils";

const ViewPassport = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        passportNumber: "",
        status: "",
        placeOfIssue: "",
        placeOfBirth: "",
        issuedDate: "",
        expiryDate: "",
        issuingCountry: "",
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        passportNumber: { type: "text", required: true },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );

  const tableData = [
    {
      title: "Passport",
      comments: "null",
      attachment:
        "1744408708_271323_2477483_6_8_0_0_0_Whatsapp-Image-20250411-at-17.07.35.jpeg ",
    },
  ];
  const columns = [
    {
      key: "title",
      label: "Title",
    },
    {
      key: "comments",
      label: "Comments",
    },

    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div className="text-info cursor-pointer">
          <Button
            title={row.attachment}
            variant="text"
            color="info"
            icon={"download"}
            size="xs"
            iconPosition="after"
          />
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <Modal
      title={"VIEW PASSPORT DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="text"
            title={"Enter Passport Number"}
            placeholder="Select Invoice Category"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
          />
          <FormFieldSet
            type="select"
            title={"Status"}
            placeholder="Select Status"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
          />
          <FormFieldSet
            type="text"
            title={"Place of Issue"}
            placeholder="Enter Place of Issue"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
          />
          <FormFieldSet
            type="datepicker"
            title={"Place of Birth"}
            placeholder="Select Place of Birth"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Issued Date"}
            placeholder="Select Issued Date"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Expiry Date"}
            placeholder="Select Expiry Date"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Issuing Country"}
            placeholder="Select Issuing Country"
            value={formData.invoiceCategory}
            onChange={(value) => handleChange("invoiceCategory", value)}
            error={errors.invoiceCategory}
          />
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>

        <div className="mt-4">
          <TableAdv tableId={`immigration_h1b_h1bview_passporti94_passportdetail_viewpassport`} rows={mappedRows} columns={columns} hideToolBar />
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button title="Close" variant="outlined" onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default ViewPassport;
